import { render } from "./EnrolleeRemoveOnboardComponent.vue?vue&type=template&id=09bf7110&scoped=true"
import script from "./EnrolleeRemoveOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeRemoveOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeRemoveOnboardComponent.vue?vue&type=style&index=0&id=09bf7110&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09bf7110"]])

export default __exports__